///<reference path="frendsUtils-module.ts"/>
module Shared {
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;

    export class DeleteConfirmationModalController {
        static $inject = ["itemType", "itemName", "$uibModalInstance"];
        constructor( public itemType: string, public itemName: string, private $modalInstance: IModalInstance) {}

        public confirm() {
            this.$modalInstance.close();
        }
        public cancel() {
            this.$modalInstance.dismiss();
        }
    }

    frendsUtilsApp.controller("DeleteConfirmationModalController", DeleteConfirmationModalController);
}